"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _logoFullColorMedium = _interopRequireDefault(require("../assets/logo-full-color-medium.png"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var Logo = function Logo(props) {
  var logoContainerStyle = _objectSpread({
    paddingTop: 20
  }, props.customLogoContainerStyle);
  var logoStyle = _objectSpread({
    display: 'block',
    margin: '0 auto 10px',
    maxHeight: '220px',
    maxWidth: '350px',
    paddingBottom: '25px',
    paddingTop: '35px'
  }, props.customStyle);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: logoContainerStyle
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "".concat(props.whitelabel.name || 'Simply Benefits', " Logo"),
    src: props.whitelabel.logo || _logoFullColorMedium["default"],
    style: logoStyle
  }));
};
var _default = exports["default"] = Logo;